Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Easing = void 0;
var _Bezier = require("./Bezier");
var _worklet_7988822508142_init_data = {
    code: "function linear(t){return t;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["linear","t"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AA6DA,SAAAA,OAAAC,CAAA,SAAAA,CAAA,CACA"}',
    version: "3.5.4"
};
var linear = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var linear = function linear(t) {
        return t;
    };
    linear.__closure = {};
    linear.__initData = _worklet_7988822508142_init_data;
    linear.__workletHash = 7988822508142;
    linear.__stackDetails = _e;
    return linear;
}();
var _worklet_15327978846457_init_data = {
    code: "function ease(t){const{Bezier}=this.__closure;return Bezier(0.42,0,1,1)(t);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["ease","t","Bezier","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAwEA,SAAAA,KAAAC,CAAA,QAAAC,MAAA,OAAAC,SAAA,QAAAD,MAAA,aAAAD,CAAA,EACA"}',
    version: "3.5.4"
};
var ease = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var ease = function ease(t) {
        return (0, _Bezier.Bezier)(0.42, 0, 1, 1)(t);
    };
    ease.__closure = {
        Bezier: _Bezier.Bezier
    };
    ease.__initData = _worklet_15327978846457_init_data;
    ease.__workletHash = 15327978846457;
    ease.__stackDetails = _e;
    return ease;
}();
var _worklet_8628631460172_init_data = {
    code: "function quad(t){return t*t;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["quad","t"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAmFA,SAAAA,KAAAC,CAAA,SAAAA,CAAA,CAAAA,CAAA,CACA"}',
    version: "3.5.4"
};
var quad = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var quad = function quad(t) {
        return t * t;
    };
    quad.__closure = {};
    quad.__initData = _worklet_8628631460172_init_data;
    quad.__workletHash = 8628631460172;
    quad.__stackDetails = _e;
    return quad;
}();
var _worklet_9374441307661_init_data = {
    code: "function cubic(t){return t*t*t;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["cubic","t"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AA8FA,SAAAA,MAAAC,CAAA,SAAAA,CAAA,CAAAA,CAAA,CAAAA,CAAA,CACA"}',
    version: "3.5.4"
};
var cubic = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var cubic = function cubic(t) {
        return t * t * t;
    };
    cubic.__closure = {};
    cubic.__initData = _worklet_9374441307661_init_data;
    cubic.__workletHash = 9374441307661;
    cubic.__stackDetails = _e;
    return cubic;
}();
var _worklet_16553371555377_init_data = {
    code: "function poly(n){return function(t){'worklet';return Math.pow(t,n);};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["poly","n","t","Math","pow"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAyGA,SAAAA,KAAAC,CAAA,kBAAAC,CAAA,EACA,UAEA,OAAAC,IAAA,CAAAC,GAAA,CAAAF,CAAA,CAAAD,CAAA,EACA,EACA"}',
    version: "3.5.4"
};
var _worklet_8160399615271_init_data = {
    code: "function anonymous(t){const{n}=this.__closure;return Math.pow(t,n);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["anonymous","t","n","__closure","Math","pow"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAiHU,QAAC,CAAAA,SAAKA,CAAAC,CAAA,QAAAC,CAAA,OAAAC,SAAA,CAEZ,MAAO,CAAAC,IAAI,CAACC,GAAG,CAACJ,CAAC,CAAEC,CAAC,CAAC,CACvB"}',
    version: "3.5.4"
};
var poly = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var poly = function poly(n) {
        return function() {
            var _e = [
                new global.Error(),
                -2,
                -27
            ];
            var anonymous = function anonymous(t) {
                return Math.pow(t, n);
            };
            anonymous.__closure = {
                n: n
            };
            anonymous.__initData = _worklet_8160399615271_init_data;
            anonymous.__workletHash = 8160399615271;
            anonymous.__stackDetails = _e;
            return anonymous;
        }();
    };
    poly.__closure = {};
    poly.__initData = _worklet_16553371555377_init_data;
    poly.__workletHash = 16553371555377;
    poly.__stackDetails = _e;
    return poly;
}();
var _worklet_8621899987563_init_data = {
    code: "function sin(t){return 1-Math.cos(t*Math.PI/2);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["sin","t","Math","cos","PI"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAuHA,SAAAA,IAAAC,CAAA,WAAAC,IAAA,CAAAC,GAAA,CAAAF,CAAA,CAAAC,IAAA,CAAAE,EAAA,IACA"}',
    version: "3.5.4"
};
var sin = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var sin = function sin(t) {
        return 1 - Math.cos(t * Math.PI / 2);
    };
    sin.__closure = {};
    sin.__initData = _worklet_8621899987563_init_data;
    sin.__workletHash = 8621899987563;
    sin.__stackDetails = _e;
    return sin;
}();
var _worklet_15893365817828_init_data = {
    code: "function circle(t){return 1-Math.sqrt(1-t*t);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["circle","t","Math","sqrt"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAiIA,SAAAA,OAAAC,CAAA,WAAAC,IAAA,CAAAC,IAAA,GAAAF,CAAA,CAAAA,CAAA,EACA"}',
    version: "3.5.4"
};
var circle = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var circle = function circle(t) {
        return 1 - Math.sqrt(1 - t * t);
    };
    circle.__closure = {};
    circle.__initData = _worklet_15893365817828_init_data;
    circle.__workletHash = 15893365817828;
    circle.__stackDetails = _e;
    return circle;
}();
var _worklet_15907471981377_init_data = {
    code: "function exp(t){return Math.pow(2,10*(t-1));}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["exp","t","Math","pow"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AA2IA,SAAAA,IAAAC,CAAA,SAAAC,IAAA,CAAAC,GAAA,OAAAF,CAAA,KACA"}',
    version: "3.5.4"
};
var exp = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var exp = function exp(t) {
        return Math.pow(2, 10 * (t - 1));
    };
    exp.__closure = {};
    exp.__initData = _worklet_15907471981377_init_data;
    exp.__workletHash = 15907471981377;
    exp.__stackDetails = _e;
    return exp;
}();
var _worklet_15898989302935_init_data = {
    code: "function elastic(bounciness=1){const p=bounciness*Math.PI;return function(t){'worklet';return 1-Math.pow(Math.cos(t*Math.PI/2),3)*Math.cos(t*p);};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["elastic","bounciness","p","Math","PI","t","pow","cos"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAqJA,SAAAA,QAAAC,UAAA,UAAAC,CAAA,CAAAD,UAAA,CAAAE,IAAA,CAAAC,EAAA,CACA,gBAAAC,CAAA,EACA,UAEA,SAAAF,IAAA,CAAAG,GAAA,CAAAH,IAAA,CAAAI,GAAA,CAAAF,CAAA,CAAAF,IAAA,CAAAC,EAAA,OAAAD,IAAA,CAAAI,GAAA,CAAAF,CAAA,CAAAH,CAAA,EACA,EACA"}',
    version: "3.5.4"
};
var _worklet_13613247223468_init_data = {
    code: "function anonymous(t){const{p}=this.__closure;return 1-Math.pow(Math.cos(t*Math.PI/2),3)*Math.cos(t*p);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["anonymous","t","p","__closure","Math","pow","cos","PI"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAkKU,QAAC,CAAAA,SAAKA,CAAAC,CAAA,QAAAC,CAAA,OAAAC,SAAA,CAEZ,MAAO,EAAC,CAAGC,IAAI,CAACC,GAAG,CAACD,IAAI,CAACE,GAAG,CAAEL,CAAC,CAAGG,IAAI,CAACG,EAAE,CAAI,CAAC,CAAC,CAAE,CAAC,CAAC,CAAGH,IAAI,CAACE,GAAG,CAACL,CAAC,CAAGC,CAAC,CAAC,CACvE"}',
    version: "3.5.4"
};
var elastic = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var elastic = function elastic() {
        var bounciness = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var p = bounciness * Math.PI;
        return function() {
            var _e = [
                new global.Error(),
                -2,
                -27
            ];
            var anonymous = function anonymous(t) {
                return 1 - Math.pow(Math.cos(t * Math.PI / 2), 3) * Math.cos(t * p);
            };
            anonymous.__closure = {
                p: p
            };
            anonymous.__initData = _worklet_13613247223468_init_data;
            anonymous.__workletHash = 13613247223468;
            anonymous.__stackDetails = _e;
            return anonymous;
        }();
    };
    elastic.__closure = {};
    elastic.__initData = _worklet_15898989302935_init_data;
    elastic.__workletHash = 15898989302935;
    elastic.__stackDetails = _e;
    return elastic;
}();
var _worklet_2360128598492_init_data = {
    code: "function back(s=1.70158){return function(t){'worklet';return t*t*((s+1)*t-s);};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["back","s","t"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAwKA,SAAAA,KAAAC,CAAA,0BAAAC,CAAA,EACA,UAEA,OAAAA,CAAA,CAAAA,CAAA,GAAAD,CAAA,IAAAC,CAAA,CAAAD,CAAA,EACA,EACA"}',
    version: "3.5.4"
};
var _worklet_7661353411314_init_data = {
    code: "function anonymous(t){const{s}=this.__closure;return t*t*((s+1)*t-s);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["anonymous","t","s","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAkLU,QAAC,CAAAA,SAAKA,CAAAC,CAAA,QAAAC,CAAA,OAAAC,SAAA,CAEZ,MAAO,CAAAF,CAAC,CAAGA,CAAC,EAAI,CAACC,CAAC,CAAG,CAAC,EAAID,CAAC,CAAGC,CAAC,CAAC,CAClC"}',
    version: "3.5.4"
};
var back = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var back = function back() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.70158;
        return function() {
            var _e = [
                new global.Error(),
                -2,
                -27
            ];
            var anonymous = function anonymous(t) {
                return t * t * ((s + 1) * t - s);
            };
            anonymous.__closure = {
                s: s
            };
            anonymous.__initData = _worklet_7661353411314_init_data;
            anonymous.__workletHash = 7661353411314;
            anonymous.__stackDetails = _e;
            return anonymous;
        }();
    };
    back.__closure = {};
    back.__initData = _worklet_2360128598492_init_data;
    back.__workletHash = 2360128598492;
    back.__stackDetails = _e;
    return back;
}();
var _worklet_5721637210615_init_data = {
    code: "function bounce(t){if(t<1/2.75){return 7.5625*t*t;}if(t<2/2.75){const t2=t-1.5/2.75;return 7.5625*t2*t2+0.75;}if(t<2.5/2.75){const t2=t-2.25/2.75;return 7.5625*t2*t2+0.9375;}const t2=t-2.625/2.75;return 7.5625*t2*t2+0.984375;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["bounce","t","t2"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAwLA,SAAAA,OAAAC,CAAA,KAAAA,CAAA,SACA,cAAAA,CAAA,CAAAA,CAAA,CACA,CACA,GAAAA,CAAA,SACA,MAAAC,EAAA,CAAAD,CAAA,UACA,MAAS,OAAgB,CAAUC,EAAA,CAAAA,EAAA,MAEjC,C,GACED,CAAA,IAAO,KAAS,CAAC,CACnB,MAAAC,EAAA,CAAAD,CAAA,WAEA,MAAS,OAAG,CAAMC,EAAA,CAAAA,EAAA,Q,MAEhB,CAAAA,EAAA,CAAOD,CAAA,CAAM,KAAK,CAAG,IAAE,CACzB,cAAAC,EAAA,CAAAA,EAAA,U"}',
    version: "3.5.4"
};
var bounce = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var bounce = function bounce(t) {
        if (t < 1 / 2.75) {
            return 7.5625 * t * t;
        }
        if (t < 2 / 2.75) {
            var _t = t - 1.5 / 2.75;
            return 7.5625 * _t * _t + 0.75;
        }
        if (t < 2.5 / 2.75) {
            var _t2 = t - 2.25 / 2.75;
            return 7.5625 * _t2 * _t2 + 0.9375;
        }
        var t2 = t - 2.625 / 2.75;
        return 7.5625 * t2 * t2 + 0.984375;
    };
    bounce.__closure = {};
    bounce.__initData = _worklet_5721637210615_init_data;
    bounce.__workletHash = 5721637210615;
    bounce.__stackDetails = _e;
    return bounce;
}();
var _worklet_9675502416406_init_data = {
    code: "function bezier(x1,y1,x2,y2){const{Bezier}=this.__closure;return{factory:function(){'worklet';return Bezier(x1,y1,x2,y2);}};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["bezier","x1","y1","x2","y2","Bezier","__closure","factory"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAiNA,SAAAA,OAAAC,EAAA,CAAAC,EAAA,CAAAC,EAAA,CAAAC,EAAA,QAAAC,MAAA,OAAAC,SAAA,QACAC,OAAA,SAAAA,CAAA,EACA,UAEA,OAAAF,MAAA,CAAAJ,EAAA,CAAAC,EAAA,CAAAC,EAAA,CAAAC,EAAA,EACA,CACA,EACA"}',
    version: "3.5.4"
};
var _worklet_16635253824977_init_data = {
    code: "function anonymous(){const{Bezier,x1,y1,x2,y2}=this.__closure;return Bezier(x1,y1,x2,y2);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["anonymous","Bezier","x1","y1","x2","y2","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAgOa,SAAAA,SAAMA,CAAA,QAAAC,MAAA,CAAAC,EAAA,CAAAC,EAAA,CAAAC,EAAA,CAAAC,EAAA,OAAAC,SAAA,CAEb,MAAO,CAAAL,MAAM,CAACC,EAAE,CAAEC,EAAE,CAAEC,EAAE,CAAEC,EAAE,CAAC,CAC/B"}',
    version: "3.5.4"
};
var bezier = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var bezier = function bezier(x1, y1, x2, y2) {
        return {
            factory: function() {
                var _e = [
                    new global.Error(),
                    -6,
                    -27
                ];
                var anonymous = function anonymous() {
                    return (0, _Bezier.Bezier)(x1, y1, x2, y2);
                };
                anonymous.__closure = {
                    Bezier: _Bezier.Bezier,
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2
                };
                anonymous.__initData = _worklet_16635253824977_init_data;
                anonymous.__workletHash = 16635253824977;
                anonymous.__stackDetails = _e;
                return anonymous;
            }()
        };
    };
    bezier.__closure = {
        Bezier: _Bezier.Bezier
    };
    bezier.__initData = _worklet_9675502416406_init_data;
    bezier.__workletHash = 9675502416406;
    bezier.__stackDetails = _e;
    return bezier;
}();
var _worklet_6096629103333_init_data = {
    code: "function bezierFn(x1,y1,x2,y2){const{Bezier}=this.__closure;return Bezier(x1,y1,x2,y2);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["bezierFn","x1","y1","x2","y2","Bezier","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAuOA,SAAAA,QAASA,CACPC,EAAA,CAAUC,EACV,CAAUC,EACV,CAAUC,EACV,CACD,OAAAC,MAAA,OAAAC,SAAA,CAEC,MAAO,CAAAD,MAAM,CAACJ,EAAE,CAAEC,EAAE,CAAEC,EAAE,CAAEC,EAAE,CAAC,CAC/B"}',
    version: "3.5.4"
};
var bezierFn = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var bezierFn = function bezierFn(x1, y1, x2, y2) {
        return (0, _Bezier.Bezier)(x1, y1, x2, y2);
    };
    bezierFn.__closure = {
        Bezier: _Bezier.Bezier
    };
    bezierFn.__initData = _worklet_6096629103333_init_data;
    bezierFn.__workletHash = 6096629103333;
    bezierFn.__stackDetails = _e;
    return bezierFn;
}();
var _worklet_1837493474379_init_data = {
    code: "function in_(easing){return easing;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["in_","easing"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAiPA,SAAAA,IAAAC,MAAA,SAAAA,MAAA,CACA"}',
    version: "3.5.4"
};
var in_ = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var in_ = function in_(easing) {
        return easing;
    };
    in_.__closure = {};
    in_.__initData = _worklet_1837493474379_init_data;
    in_.__workletHash = 1837493474379;
    in_.__stackDetails = _e;
    return in_;
}();
var _worklet_7718549646703_init_data = {
    code: "function out(easing){return function(t){'worklet';return 1-easing(1-t);};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["out","easing","t"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAyPA,SAAAA,IAAAC,MAAA,kBAAAC,CAAA,EACA,UAEA,MAAS,EAAG,CAACD,MAAwC,GAAAC,CAAA,EAEnD,E"}',
    version: "3.5.4"
};
var _worklet_5429450466877_init_data = {
    code: "function anonymous(t){const{easing}=this.__closure;return 1-easing(1-t);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["anonymous","t","easing","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AA8PU,QAAC,CAAAA,SAAKA,CAAAC,CAAA,QAAAC,MAAA,OAAAC,SAAA,CAEZ,MAAO,EAAC,CAAGD,MAAM,CAAC,CAAC,CAAGD,CAAC,CAAC,CAC1B"}',
    version: "3.5.4"
};
var out = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var out = function out(easing) {
        return function() {
            var _e = [
                new global.Error(),
                -2,
                -27
            ];
            var anonymous = function anonymous(t) {
                return 1 - easing(1 - t);
            };
            anonymous.__closure = {
                easing: easing
            };
            anonymous.__initData = _worklet_5429450466877_init_data;
            anonymous.__workletHash = 5429450466877;
            anonymous.__stackDetails = _e;
            return anonymous;
        }();
    };
    out.__closure = {};
    out.__initData = _worklet_7718549646703_init_data;
    out.__workletHash = 7718549646703;
    out.__stackDetails = _e;
    return out;
}();
var _worklet_7048715165105_init_data = {
    code: "function inOut(easing){return function(t){'worklet';if(t<0.5){return easing(t*2)/2;}return 1-easing((1-t)*2)/2;};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["inOut","easing","t"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAoQA,SAAAA,MAAAC,MAAA,kBAAAC,CAAA,EACA,UAEA,GAAAA,CAAA,MACA,OAAAD,MAAA,CAAAC,CAAA,MACA,CAEE,MAAQ,GAAAD,MAAC,CAAK,GAAAC,CAAA,O"}',
    version: "3.5.4"
};
var _worklet_10791933647172_init_data = {
    code: "function anonymous(t){const{easing}=this.__closure;if(t<0.5){return easing(t*2)/2;}return 1-easing((1-t)*2)/2;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["anonymous","t","easing","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AA2QU,QAAC,CAAAA,SAAKA,CAAAC,CAAA,QAAAC,MAAA,OAAAC,SAAA,CAEZ,GAAIF,CAAC,CAAG,GAAG,CAAE,CACX,MAAO,CAAAC,MAAM,CAACD,CAAC,CAAG,CAAC,CAAC,CAAG,CAAC,CAC1B,CACA,MAAO,EAAC,CAAGC,MAAM,CAAC,CAAC,CAAC,CAAGD,CAAC,EAAI,CAAC,CAAC,CAAG,CAAC,CACpC"}',
    version: "3.5.4"
};
var inOut = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var inOut = function inOut(easing) {
        return function() {
            var _e = [
                new global.Error(),
                -2,
                -27
            ];
            var anonymous = function anonymous(t) {
                if (t < 0.5) {
                    return easing(t * 2) / 2;
                }
                return 1 - easing((1 - t) * 2) / 2;
            };
            anonymous.__closure = {
                easing: easing
            };
            anonymous.__initData = _worklet_10791933647172_init_data;
            anonymous.__workletHash = 10791933647172;
            anonymous.__stackDetails = _e;
            return anonymous;
        }();
    };
    inOut.__closure = {};
    inOut.__initData = _worklet_7048715165105_init_data;
    inOut.__workletHash = 7048715165105;
    inOut.__stackDetails = _e;
    return inOut;
}();
var _worklet_13898404482597_init_data = {
    code: "function steps(n=10,roundToNextStep=true){return function(t){'worklet';const value=Math.min(Math.max(t,0),1)*n;if(roundToNextStep){return Math.ceil(value)/n;}return Math.floor(value)/n;};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["steps","n","roundToNextStep","t","value","Math","min","max","ceil","floor"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AAoRA,SAAAA,MAAAC,CAAA,IAAAC,eAAA,uBAAAC,CAAA,EACA,UAEA,MAAAC,KAAA,CAAAC,IAAA,CAAAC,GAAA,CAAAD,IAAA,CAAAE,GAAA,CAAAJ,CAAA,OAAAF,CAAA,CACA,GAAAC,eAAA,EACA,OAAAG,IAAA,CAAAG,IAAA,CAAAJ,KAAA,EAAAH,CAAA,CACA,CAEE,MAAQ,CAAAI,IAAA,CAAAI,KAAC,CAAKL,KAAA,EAAAH,CAAA,C"}',
    version: "3.5.4"
};
var _worklet_775466327407_init_data = {
    code: "function anonymous(t){const{n,roundToNextStep}=this.__closure;const value=Math.min(Math.max(t,0),1)*n;if(roundToNextStep){return Math.ceil(value)/n;}return Math.floor(value)/n;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts",
    sourceMap: '{"version":3,"names":["anonymous","t","n","roundToNextStep","__closure","value","Math","min","max","ceil","floor"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Easing.ts"],"mappings":"AA4RU,QAAC,CAAAA,SAAKA,CAAAC,CAAA,QAAAC,CAAA,CAAAC,eAAA,OAAAC,SAAA,CAEZ,KAAM,CAAAC,KAAK,CAAGC,IAAI,CAACC,GAAG,CAACD,IAAI,CAACE,GAAG,CAACP,CAAC,CAAE,CAAC,CAAC,CAAE,CAAC,CAAC,CAAGC,CAAC,CAC7C,GAAIC,eAAe,CAAE,CACnB,MAAO,CAAAG,IAAI,CAACG,IAAI,CAACJ,KAAK,CAAC,CAAGH,CAAC,CAC7B,CACA,MAAO,CAAAI,IAAI,CAACI,KAAK,CAACL,KAAK,CAAC,CAAGH,CAAC,CAC9B"}',
    version: "3.5.4"
};
var steps = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var steps = function steps() {
        var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
        var roundToNextStep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return function() {
            var _e = [
                new global.Error(),
                -3,
                -27
            ];
            var anonymous = function anonymous(t) {
                var value = Math.min(Math.max(t, 0), 1) * n;
                if (roundToNextStep) {
                    return Math.ceil(value) / n;
                }
                return Math.floor(value) / n;
            };
            anonymous.__closure = {
                n: n,
                roundToNextStep: roundToNextStep
            };
            anonymous.__initData = _worklet_775466327407_init_data;
            anonymous.__workletHash = 775466327407;
            anonymous.__stackDetails = _e;
            return anonymous;
        }();
    };
    steps.__closure = {};
    steps.__initData = _worklet_13898404482597_init_data;
    steps.__workletHash = 13898404482597;
    steps.__stackDetails = _e;
    return steps;
}();
var EasingObject = {
    linear: linear,
    ease: ease,
    quad: quad,
    cubic: cubic,
    poly: poly,
    sin: sin,
    circle: circle,
    exp: exp,
    elastic: elastic,
    back: back,
    bounce: bounce,
    bezier: bezier,
    bezierFn: bezierFn,
    steps: steps,
    in: in_,
    out: out,
    inOut: inOut
};
var Easing = exports.Easing = EasingObject;
